import { render, staticRenderFns } from "./miaoshu-fenzu-fenlei.vue?vue&type=template&id=06395ce2&"
import script from "./miaoshu-fenzu-fenlei.vue?vue&type=script&lang=ts&"
export * from "./miaoshu-fenzu-fenlei.vue?vue&type=script&lang=ts&"
import style0 from "./miaoshu-fenzu-fenlei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports